import gql from 'graphql-tag';

export const LISTADO_TIPO_PRODUCTOS = gql(`
    query listadoTipoProductos ($idioma: String) {
        listadoTipoProductos {
            codigo
            plataforma
            literalTipoProducto(idioma: $idioma) {
                clave
                valor
            }
            literalPlataforma(idioma: $idioma) {
                clave
                valor
            }
        }
    }
`);

export const LISTADO_TIPO_PRODUCTOS_POR_PLATAFORMA = gql(`
    query listadoTipoProductosPorPlataforma ($idioma: String, $plataforma: String) {
        listadoTipoProductosPorPlataforma(plataforma: $plataforma) {
            codigo
            plataforma
            literalTipoProducto(idioma: $idioma) {
                clave
                valor
            }
            literalPlataforma(idioma: $idioma) {
                clave
                valor
            }
        }
    }
`);

export const LISTADO_TIPO_PRODUCTOS_POR_PLATAFORMA_SIN_TARIFA = gql(`
    query listadoTipoProductosPorPlataformaSinTarifa ($idioma: String, $plataforma: String) {
        listadoTipoProductosPorPlataformaSinTarifa(plataforma: $plataforma) {
            codigo
            plataforma
            literalTipoProducto(idioma: $idioma) {
                clave
                valor
            }
            literalPlataforma(idioma: $idioma) {
                clave
                valor
            }
        }
    }
`);


export const LISTADO_TIPO_PRODUCTOS_POR_PLATAFORMA_CON_TARIFA = gql(`
    query listadoTipoProductosPorPlataformaConTarifa ($idioma: String, $plataforma: String) {
        listadoTipoProductosPorPlataformaConTarifa(plataforma: $plataforma) {
            codigo
            plataforma
            literalTipoProducto(idioma: $idioma) {
                clave
                valor
            }
            literalPlataforma(idioma: $idioma) {
                clave
                valor
            }
        }
    }
`);


export const GET_TIPO_PRODUCTO = gql(`
    query tipoProducto($codigo: String, $idioma: String) {
        tipoProducto(codigo: $codigo) {
            codigo
            tarifa
            divisa
            plataforma
            literalTipoProducto(idioma: $idioma) {
                clave
                valor
            }
            literalPlataforma(idioma: $idioma) {
                clave
                valor
            }
        }
    }
`);

export const QUERY_PRODUCTOS_ACTIVOS = gql(`
    query listaProductosActivosIciredPortalClientes {
        listaProductosActivosIciredPortalClientes {
            codigo
            nombre
            descripcion
            tipo
            tarifa
            divisa
        }
    }
`);

export const QUERY_PRODUCTOS_ACTIVOS_INCLUSION = gql(`
    query listaProductosInclusionActivosIciredPortalClientes {
        listaProductosInclusionActivosIciredPortalClientes {
            codigo
            nombre
            descripcion
            tipo
            tarifa
            divisa
        }
    }
`);

export const QUERY_PRODUCTOS_ACTIVOS_BUSQUEDA = gql(`
    query listaProductosBusquedaActivosIciredPortalClientes {
        listaProductosBusquedaActivosIciredPortalClientes {
            codigo
            nombre
            descripcion
            tipo
            tarifa
            divisa
        }
    }
`);